import styled from "@emotion/styled";
import { fontRoboto } from "@product/scmp-sdk";

import { EntityLink } from "~/components/entity-link";

export const LiveTagContainer = styled.div`
  &:not(:empty):not(:last-child) {
    margin-block-end: 12px;
  }
`;

export const Header = styled.div``;
export const Cover = styled.div``;
export const Content = styled.div``;
export const Footer = styled.div``;
export const PrintHeadline = styled.div``;

export const Container = styled.div``;

export const StyledEntityLink = styled(EntityLink)`
  display: grid;
  grid:
    "header . cover" min-content
    "content . cover" min-content
    "footer . cover" min-content
    "print-headline . cover" min-content
    ". . cover" min-content
    / 1fr 12px 60px;

  inline-size: 100%;
  padding-block: 16px;
  box-sizing: border-box;

  &:hover {
    ${Header} {
      color: #2c4692;
    }
  }

  ${props => props.theme.breakpoints.up("tablet")} {
    grid:
      "header . cover" min-content
      "content . cover" min-content
      "footer . cover" min-content
      "print-headline . cover" min-content
      ". . cover" min-content
      / 1fr 20px 80px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    padding-block: 20px;
  }

  ${Cover} {
    grid-area: cover;

    inline-size: 60px;
    block-size: 60px;

    ${props => props.theme.breakpoints.up("tablet")} {
      inline-size: 80px;
      block-size: 80px;
    }
  }

  ${Header} {
    grid-area: header;

    display: inline-block;

    margin-block-end: 12px;

    font-weight: 700;
    font-size: 16px;
    font-family: ${fontRoboto};
    line-height: 21px;
    text-overflow: ellipsis;

    ${props => props.theme.breakpoints.up("desktop")} {
      font-weight: 700;
      font-size: 20px;
      font-family: ${fontRoboto};
      line-height: 26px;
    }
  }

  ${Content} {
    grid-area: content;

    display: inline-block;
    display: -webkit-box;

    margin-block-end: 12px;

    color: #333333;
    font-size: 14px;
    font-family: ${fontRoboto};
    line-height: 18px;
    text-overflow: ellipsis;

    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }

  ${Footer} {
    grid-area: footer;

    color: #999999;
    font-size: 14px;
    font-family: ${fontRoboto};
    line-height: 21px;
  }

  ${PrintHeadline} {
    grid-area: print-headline;

    margin-block-start: 12px;

    font-size: 12px;
    font-family: ${fontRoboto};
    line-height: 14px;

    &:empty {
      display: none;
    }
  }
`;
